import { render, staticRenderFns } from "./DingDing.vue?vue&type=template&id=6fc44052&scoped=true"
import script from "./DingDing.vue?vue&type=script&lang=js"
export * from "./DingDing.vue?vue&type=script&lang=js"
import style0 from "./DingDing.vue?vue&type=style&index=0&id=6fc44052&prod&scoped=scoped&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc44052",
  null
  
)

export default component.exports